module.exports = __webpack_public_path__ + "img/九州机构通客户操作手册10651.9c1d8078.png";